import { logError } from "Utils/logger";
import { shouldNotifyHoneybadger } from "ZeroRuby/snippets/honeybadger";

// Prune the allPlans array from the state for error tracking.
const stateSanitizer = (state) => {
  const stateCopy = { ...state };
  stateCopy.allPlans = [];
  stateCopy.entities = {};
  return stateCopy;
};

const honeybadgerMiddleware = (store) => (next) => (action) => {
  try {
    return next(action);
  } catch (err) {
    if (shouldNotifyHoneybadger) {
      let stateToSend = store.getState();

      if (stateSanitizer && typeof stateSanitizer === "function") {
        stateToSend = stateSanitizer(stateToSend);
      }

      const splitAction = action?.type.split("/");
      const name = splitAction[0];
      const component = "redux";
      const actionName = splitAction[splitAction.length - 1];
      logError(err, { name, component, action: actionName }, { state: stateToSend });
    } else {
      throw err;
    }
  }
};

export default honeybadgerMiddleware;
